import React from 'react';

const GrandOasisFloorplan = () => {
  return (
    <div>
      <img src="/images/floorplanC.jpg" alt="Floorplan C" style={{ width: '100%' }} />
      <img src="/images/floorplanE.jpg" alt="Floorplan E" style={{ width: '100%' }} />
    </div>
  );
};

export default GrandOasisFloorplan;
